/* notify-modal.js — Open/close behavior for the Notify Me modal.
   Form submission is handled natively by Shopify via {% form 'customer' %}. */

(function () {
  var overlay = document.getElementById('notify-modal-overlay');
  if (!overlay) return;

  var closeBtn = overlay.querySelector('.notify-modal__close');
  var emailInput = overlay.querySelector('.notify-modal__email');

  function open() {
    overlay.setAttribute('aria-hidden', 'false');
    overlay.style.display = 'flex';
    void overlay.offsetHeight;
    overlay.classList.add('notify-modal--visible');
    if (emailInput) emailInput.focus();
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('notify-modal--visible');
    overlay.addEventListener('transitionend', function handler() {
      overlay.removeEventListener('transitionend', handler);
      overlay.style.display = 'none';
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  }

  closeBtn.addEventListener('click', close);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('notify-modal--visible')) {
      close();
    }
  });

  window.openNotifyModal = open;
})();
